export default "__VITE_ASSET__cb202034__"